import { createFileRoute } from "@tanstack/react-router";
import { AdminUsersPage } from "@/components/admin/pages/AdminUsersPage";

export const Route = createFileRoute("/pulse-ops-x7k2/users")({
  component: AdminUsersPage,
});
